import { Fragment, useState, useMemo } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import Images from "../../constant/Images";

export default function CheckBox({
  data,
  handleFilterBundleTours,
  handleAddBunleTours,
  tourInBundle,
  bundleTours,
}: any) {
  const [search, setSearch] = useState("");

  const handleChange = (e: any, elm: any) => {
    if (e.target.checked) {
      handleAddBunleTours({ ...elm, bundleInTourId: null });
    } else {
      handleFilterBundleTours(elm);
    }
  };

  type TourName = { text: string; language: string }[];

  const getEngTourName = (tourName: any): string => {
    if (!tourName) return "Unknown";
    if (Array.isArray(tourName)) {
      const obj = tourName.find((item: any) => item?.language === "en");
      if (obj?.text) return obj.text;
      if (tourName[0]?.text) return tourName[0].text;
      return "Unknown";
    }
    if (typeof tourName !== "string") return "Unknown";
    try {
      const parsed: TourName = JSON.parse(tourName);
      if (Array.isArray(parsed)) {
        const obj = parsed.find((item) => item.language === "en");
        if (obj?.text) return obj.text;
        if (parsed[0]?.text) return parsed[0].text;
      }
    } catch {
      return tourName;
    }
    return "Unknown";
  };

  const query = search.trim().toLowerCase();
  const filteredData = useMemo(() => {
    if (!data?.length) return [];
    if (!query) return data;
    return data.filter((item: any) => {
      const name = getEngTourName(item?.name).toLowerCase();
      const productId = (item?.productId || "").toString().toLowerCase();
      return name.includes(query) || productId.includes(query);
    });
  }, [data, query]);

  return (
    <>
      <Menu as="div" className="relative inline-block text-left w-full">
        <div className="w-full border border-slate-300 rounded-md">
          <div className="w-full flex   gap-x-1.5 rounded-md bg-white px-3 py-2.5 text-sm font-semibold text-gray-900 overflow-x-auto overflow-y-hidden">
            <div className="flex w-[98%] overflow-x-auto">
              {bundleTours?.map((elm: any) => (
                <div key={elm?.id ?? elm?.originTourId} className="flex mr-2 overflow-x-hidden overflow-y-auto">
                  <div className="flex items-center px-2 py-0  border border-lightgray rounded-lg">
                    <p className="text-sm flex items-center  w-fit  ">
                      {getEngTourName(elm?.tourBundelsDetails?.name || elm?.name)}
                    </p>
                    <span>
                      <img
                        src={Images.closecircle}
                        alt=""
                        onClick={() => {
                          handleFilterBundleTours(elm);
                        }}
                        className="w-4 h-4 ml-2 cursor-pointer"
                      />
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-[1%] flex items-center justify-center">
              <Menu.Button>
                <ChevronDownIcon
                  className="h-5 w-5 text-gray-400 text-right ml-auto flex justify-end "
                  aria-hidden="true"
                />
              </Menu.Button>
            </div>
          </div>
        </div>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute z-10 mt-2 w-full origin-top-right rounded-md bg-white shadow-lg focus:outline-none">
            <div className="p-2 border-b border-gray-100 bg-gray-50 sticky top-0">
              <input
                type="text"
                autoFocus
                placeholder="Search tours by name or productId..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => e.stopPropagation()}
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm outline-none focus:border-aqua"
              />
              <div className="flex justify-between items-center mt-1 px-1">
                <span className="text-xs text-gray-500">
                  {filteredData.length} tour{filteredData.length === 1 ? "" : "s"}
                  {query ? ` matching "${search}"` : ""}
                </span>
                <span className="text-xs text-aqua font-semibold">
                  {bundleTours?.length || 0} selected
                </span>
              </div>
            </div>
            <div className="max-h-[280px] overflow-y-auto">
              {filteredData.length ? (
                filteredData.map((item: any) => (
                  <div key={item.id} className="flex items-center my-2 px-2">
                    <input
                      id={`bundle-tour-${item.id}`}
                      aria-describedby={`bundle-tour-${item.id}`}
                      type="checkbox"
                      onChange={(e) => handleChange(e, item)}
                      checked={!!tourInBundle?.[item.id]}
                      onClick={(e) => e.stopPropagation()}
                      className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded cursor-pointer"
                    />
                    <label
                      htmlFor={`bundle-tour-${item.id}`}
                      className="text-sm ml-3 font-medium text-gray-900 cursor-pointer flex-1"
                      onClick={(e) => e.stopPropagation()}
                    >
                      {getEngTourName(item?.name)}
                      {item?.productId && (
                        <span className="ml-2 text-xs text-gray-400 font-normal">
                          {item.productId}
                        </span>
                      )}
                    </label>
                  </div>
                ))
              ) : (
                <div className="px-4 py-6 text-center text-gray-400 text-sm">
                  No tours match "{search}"
                </div>
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </>
  );
}
